import type { JSX } from "react";
import { Exclamation } from "@repo/icons";
import { cn } from "@repo/lib";
import {
  EmptyStateV2Content,
  EmptyStateV2Description,
  EmptyStateV2Icon,
  EmptyStateV2Root,
} from "@/components/empty-state-v2.tsx";
import { Button } from "@/components/button.tsx";

interface ErrorCardProps {
  onClick?: () => void;
}

export const ErrorCard = ({ onClick }: ErrorCardProps): JSX.Element => {
  return (
    <EmptyStateV2Root className="items-start p-4">
      <EmptyStateV2Content>
        <EmptyStateV2Icon
          className={cn("bg-danger-50 p-2 fill-danger-500 stroke-0")}
          Icon={Exclamation}
        />
        <EmptyStateV2Description className="text-black font-medium text-sm">
          Ocorreu um erro! Por favor tente novamente ou recarregue a página.
        </EmptyStateV2Description>
      </EmptyStateV2Content>
      <Button
        className="px-3 min-h-0 w-fit text-xs"
        type="button"
        rounded
        size="small"
        onClick={onClick}
      >
        Tentar novamente
      </Button>
    </EmptyStateV2Root>
  );
};
